"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldVisibilitySettingsPopup = void 0;
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const react_sortablejs_1 = require("react-sortablejs");
const ZButton_1 = require("../../components/ZButton/ZButton");
const ZPopup_1 = require("../../components/ZPopup/ZPopup");
const ZTooltip_1 = require("../../components/ZTooltip/ZTooltip");
const icons_1 = require("../../icons");
const languages_1 = require("../../languages");
const useResizeObserver_1 = require("../useResizeObserver");
const react_1 = __importDefault(require("react"));
const lodash_1 = __importDefault(require("lodash"));
const handle_dark_png_1 = __importDefault(require("../../images/handle_dark.png"));
const handle_light_png_1 = __importDefault(require("../../images/handle_light.png"));
const styled_components_1 = __importDefault(require("styled-components"));
const fieldStates = {
    Hidden: { required: false, hidden: true, editable: true },
    Visible: { required: false, hidden: false, editable: true },
    Required: { required: true, hidden: false, editable: true },
    ReadOnly: { required: false, hidden: false, editable: false }
};
const PopupGrid = styled_components_1.default.div `
   display: grid;
   text-align: start;
   grid-template-rows: 15px auto 50px;
   grid-template-columns: 1fr;
   background-color: white;
   width: 100%;
   overflow-y: hidden;
   &:active {
      cursor: grabbing;
   }
`;
const DroppablesGrid = styled_components_1.default.div `
   display: grid;
   grid-template-columns: 1fr 1px ${props => props.numberOfColumns ? props.numberOfColumns + "fr" : "3fr"};
   & #visibleFieldsArea {
      padding: 0px 30px 0px 30px;
      min-height: 150px;
      margin: 6px;
      border: 2px gainsboro dotted;
   }
   & #hiddenFieldsArea {
      border: 2px gainsboro dotted;
      min-height: 150px;
      margin: 6px;
   }
`;
const Divider = styled_components_1.default.div `
   background-color: black;
`;
const EmptySpace = styled_components_1.default.div `
   width: 80%;
   height: 40px;
   border: 1px dashed black;
   padding: 5px;
   margin: 12px;
   cursor: grab;
   &:active {
      cursor: grabbing !important;
   }
   &.sortable-ghost,
   &.sortable-chosen,
   &.sortable-drag,
   &.sortable-fallback {
      opacity: 80%;
      cursor: grabbing !important;
      &:active {
         cursor: grabbing !important;
      }
   }
`;
const Field = styled_components_1.default.div `
   margin: 0px 20px 0px 30px;
   overflow: hidden;
   text-overflow: ellipsis;
   white-space: nowrap;
   max-width: 90%;
   height: 40px;
   line-height: 38px;
   position: relative;
   user-select: none;
   & .z-checkbox {
      position: relative;
   }
   justify-self: center;
   & div {
      height: 16px;
      color: ${props => (props.hidden ? "#f9f9f9" : "#3d3d3dc4")};
   }
`;
const FieldPlaceholder = react_1.default.forwardRef((props, ref) => {
    const { onClick, hidden, editable, required, children, className, ignoreFVS, id } = props, { languageId } = react_1.default.useContext(languages_1.llContext);
    const requiredIcon = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: "circle", transform: "grow-1", color: "#a94442" }),
        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: "circle" })));
    const lockIcon = (react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: "lock", color: hidden ? "#f9f9f9" : "#3d3d3dc4", transform: "shrink-3 right-14 up-12" }));
    const icon = react_1.default.useMemo(() => id > 0 ? (react_1.default.createElement(ZTooltip_1.ZTooltip, { title: `${ignoreFVS ? "Always" : ""}${hidden
            ? "Hidden"
            : !editable
                ? "ReadOnly"
                : !required
                    ? "Visible"
                    : "Required"}` },
        react_1.default.createElement("div", { className: "icon" },
            react_1.default.createElement("span", { className: "fa-layers fa-fw" },
                hidden
                    ? icons_1.hidden
                    : !editable
                        ? icons_1.readOnly
                        : !required
                            ? icons_1.visible
                            : requiredIcon,
                ignoreFVS ? lockIcon : null)))) : (react_1.default.createElement(ZTooltip_1.ZTooltip, { title: "RemoveEmptySpace" },
        react_1.default.createElement("div", { className: "icon", style: { cursor: "pointer" } },
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: "times" })))), [editable, hidden, ignoreFVS, lockIcon, required, requiredIcon, id]);
    const fieldText = languages_1.ll({
        key: children &&
            children.props &&
            (children.props.label || children.props.header),
        languageId
    });
    return (react_1.default.createElement("div", { className: className, onClick: onClick, "data-ignorefvs": ignoreFVS, ref: ref },
        react_1.default.createElement(PlaceholderGrid, null,
            react_1.default.createElement("div", { className: "handle" },
                react_1.default.createElement("img", { src: hidden ? handle_dark_png_1.default : handle_light_png_1.default })),
            react_1.default.createElement(Field, { className: "field" }, id > 0 ? (children &&
                children.props &&
                children.props.localize === false ? (children.props.label || children.props.header) : (react_1.default.createElement("span", { title: fieldText },
                react_1.default.createElement(react_1.default.Fragment, null, fieldText)))) : (react_1.default.createElement("span", null, languages_1.ll({ key: "EmptySpace", languageId })))),
            icon)));
});
const PlaceholderGrid = styled_components_1.default.div `
   display: grid;
   grid-template-rows: 1fr;
   grid-template-columns: 20px auto 40px;
   align-items: center;
   justify-content: space-between;
`;
const StyledPlaceholder = styled_components_1.default(FieldPlaceholder) `
   padding: 5px;
   margin: 12px;
   height: 40px;
   overflow: hidden;
   width: 80%;
   cursor: grab;
   &:active {
      cursor: grabbing !important;
   }
   background-color: ${props => props.hidden
    ? "#3d3d3dc4"
    : props.editable === false
        ? "#eee"
        : "#ffffff"};
   color: ${props => props.hidden
    ? "#f9f9f9"
    : props.required
        ? props.theme["alert-color"]
        : "#3d3d3dc4"};
   opacity: ${props => (props.hidden || props.id < 0 ? "50%" : "100%")};
   & .handle {
      position: relative;
      top: 2px;
   }

   & input {
      background-color: transparent;
   }

   &.sortable-ghost,
   &.sortable-chosen,
   &.sortable-drag *,
   &.sortable-fallback {
      opacity: 80%;
      & .handle {
         color: transparent;
      }
      cursor: grabbing !important;
      &:active {
         cursor: grabbing !important;
      }
   }
   & .icon,
   .icon * {
      position: relative;
      width: 40px;
   }
   & .portal-label-text {
      display: none;
   }
   & .portal-label-header {
      font-size: 16px;
      position: relative;
   }
   border: ${props => props.required
    ? "1px solid #a94442"
    : props.id < 0
        ? "1px dashed black"
        : "1px solid black"};
   font-family: ${props => props.theme["font-family"]};
   justify-content: end;
`;
const determineState = (props) => {
    return (Object.keys(fieldStates).find(state => (props.required || false) === fieldStates[state].required &&
        (props.editable || false) === fieldStates[state].editable &&
        (props.hidden || false) === fieldStates[state].hidden) || "Visible");
};
const TitleContainer = styled_components_1.default.div `
   display: inline-block;
   width: 100%;
`;
const TitleWrapper = styled_components_1.default.div `
   display: inline-block;
   white-space: initial;
   width: calc(100% - 230px);
`;
const AutoCompleteWrapper = styled_components_1.default.div `
   display: inline-block;
   width: 230px;
`;
let negativeIdCount = 0;
const getUniqueNegativeId = () => {
    negativeIdCount--;
    return negativeIdCount;
};
exports.FieldVisibilitySettingsPopup = styled_components_1.default(react_1.default.memo((props) => {
    const { allowedFieldStates, containerId } = props;
    const allFieldStates = [
        "Hidden",
        "Visible",
        "Required",
        "ReadOnly"
    ];
    const reducer = (state, action) => {
        let returnValue = null;
        if (action.type === "toggleItem") {
            let allowedStates = allowedFieldStates || allFieldStates;
            const visibleItem = state.visibleFields.find(f => f.id === action.payload.id &&
                f.fvsLevelId === state.selectedFVSLevelId);
            const hiddenItem = state.hiddenFields.find(f => f.id === action.payload.id &&
                f.fvsLevelId === state.selectedFVSLevelId);
            const item = visibleItem || hiddenItem;
            if (!item) {
                return state;
            }
            else if (item &&
                item.element &&
                item.element.type &&
                item.element.type.displayName === "ZCheckbox") {
                allowedStates = lodash_1.default.without(allowedStates, "Required");
            }
            if (item.id < 0) {
                return {
                    ...state,
                    visibleFields: lodash_1.default.without(state.visibleFields, item),
                    hiddenFields: lodash_1.default.without(state.hiddenFields, item)
                };
            }
            const { hidden, required, editable } = item;
            const currentState = determineState({
                hidden,
                required,
                editable
            }) || "Visible";
            const nextState = currentState
                ? (allowedStates.indexOf(currentState) +
                    1) %
                    allowedStates.length
                : 0;
            if (hiddenItem) {
                returnValue = {
                    ...state,
                    hiddenFields: lodash_1.default.without(state.hiddenFields, hiddenItem),
                    visibleFields: lodash_1.default.concat(state.visibleFields, {
                        ...hiddenItem,
                        ...fieldStates[allowedStates[nextState]]
                    })
                };
                return returnValue;
            }
            if (visibleItem) {
                if (allowedStates[nextState] === "Hidden") {
                    returnValue = {
                        ...state,
                        visibleFields: lodash_1.default.without(state.visibleFields, visibleItem),
                        hiddenFields: lodash_1.default.concat(state.hiddenFields, {
                            ...visibleItem,
                            ...fieldStates["Hidden"]
                        })
                    };
                    return returnValue;
                }
            }
            returnValue = {
                ...state,
                visibleFields: state.visibleFields.map(f => f.id === action.payload.id
                    ? {
                        ...f,
                        ...fieldStates[allowedStates[nextState]]
                    }
                    : f)
            };
            return returnValue;
        }
        if (action.type === "setVisibleFields") {
            if (!action.payload) {
                return state;
            }
            const newFields = action.payload &&
                action.payload.fields.map(field => {
                    const currentState = determineState(field);
                    return { ...field, ...fieldStates[currentState] }; // enforce only valid combinations of state flags
                });
            const selectedFields = state.visibleFields.filter(f => f.fvsLevelId === state.selectedFVSLevelId);
            const remainingFields = state.visibleFields.filter(f => f.fvsLevelId !== state.selectedFVSLevelId);
            if (lodash_1.default.isEqual(selectedFields, newFields)) {
                return state;
            }
            return {
                ...state,
                visibleFields: [
                    ...newFields
                        .filter(f => !!f)
                        .map(f => ({
                        ...f,
                        ...(f.hidden
                            ? fieldStates["Visible"]
                            : !f.editable
                                ? fieldStates["ReadOnly"]
                                : f.required
                                    ? fieldStates["Required"]
                                    : {})
                    })),
                    ...remainingFields
                ]
            };
        }
        if (action.type === "setHiddenFields") {
            if (!action.payload) {
                return state;
            }
            const newFields = action.payload && action.payload.fields;
            const selectedFields = state.hiddenFields.filter(f => f.fvsLevelId === state.selectedFVSLevelId);
            const remainingFields = state.hiddenFields.filter(f => f.fvsLevelId !== state.selectedFVSLevelId);
            if (lodash_1.default.isEqual(selectedFields, newFields)) {
                return state;
            }
            return {
                ...state,
                hiddenFields: [
                    ...newFields
                        .filter(f => !!f && f.id > 0)
                        .map(f => ({
                        ...f,
                        ...(!f.hidden ? fieldStates["Hidden"] : {})
                    })),
                    ...remainingFields
                ]
            };
        }
        if (action.type === "setSelectedFVSLevel") {
            return {
                ...state,
                selectedFVSLevel: action.payload,
                selectedFVSLevelId: action.payload.Id > 0 ? action.payload.Id : undefined
            };
        }
        return state;
    };
    const visibleFields = react_1.default.useMemo(() => {
        let addEmptySpaces = (visibleFields, fvsLevelId) => {
            return visibleFields.reduce((prev, current, index, array) => {
                const currentSortOrder = current.element && current.element.props.sortOrder;
                if (index === 0) {
                    for (let i = 0; i < currentSortOrder; i++) {
                        prev.push({
                            fieldName: "",
                            id: getUniqueNegativeId(),
                            fvsLevelId: fvsLevelId,
                            ...fieldStates["Visible"]
                        });
                    }
                    prev.push(current);
                    return prev;
                }
                const previousElement = array[index - 1].element;
                const previousSortOrder = previousElement && previousElement.props.sortOrder;
                for (let i = previousSortOrder + 1; i < currentSortOrder; i++) {
                    prev.push({
                        fieldName: "",
                        id: getUniqueNegativeId(),
                        fvsLevelId: fvsLevelId,
                        ...fieldStates["Visible"]
                    });
                }
                prev.push(current);
                return prev;
            }, []);
        };
        let fields = props.fields.filter(f => !f.hidden);
        let result = addEmptySpaces(fields.filter(f => !f.fvsLevelId));
        if (props.fvsLevelData) {
            props.fvsLevelData.forEach(fvsLevel => {
                result.push(...addEmptySpaces(fields.filter(f => f.fvsLevelId === fvsLevel.Id), fvsLevel.Id));
            });
        }
        return result;
    }, [props.fields, props.fvsLevelData]);
    const languageId = languages_1.useLanguage();
    const defaultFVSLevel = react_1.default.useMemo(() => ({
        Id: -1,
        CodeNumber: languages_1.ll({ key: "Default", languageId }),
        Value: languages_1.ll({ key: "Default", languageId })
    }), [languageId]);
    const autoCompleteData = react_1.default.useMemo(() => props.fvsLevelData
        ? [defaultFVSLevel, ...props.fvsLevelData]
        : undefined, [defaultFVSLevel, props.fvsLevelData]);
    const initialFVSLevel = props.fvsLevelId && props.fvsLevelData
        ? props.fvsLevelData.find((e) => e.Id === props.fvsLevelId) || defaultFVSLevel
        : undefined;
    const [state, dispatch] = react_1.default.useReducer(reducer, {
        hiddenFields: props.fields.filter(f => f.hidden),
        visibleFields: visibleFields,
        selectedFVSLevel: initialFVSLevel,
        selectedFVSLevelId: initialFVSLevel ? initialFVSLevel.Id : undefined
    });
    const FieldList = styled_components_1.default.div `
            display: inline-block;
            width: 100%;
            height: 100%;
         `;
    const toggleItem = (id) => {
        const payload = { id };
        dispatch({
            type: "toggleItem",
            payload
        });
    };
    const Instructions = styled_components_1.default.div `
            font-weight: normal;
            font-size: 12px;
            display: inline-block;
            margin-right: 10px;
         `;
    const PopupButtons = styled_components_1.default.div `
            display: flex;
            flex-direction: row-reverse;
            justify-self: flex-end;
            margin: 5px;
         `;
    const localizedId = languages_1.ll(containerId || "");
    const localizedTitle = localizedId.startsWith("Not Localized")
        ? languages_1.ll({
            key: "EditFVSPopupTitle",
            variables: [containerId || ""],
            languageId
        })
        : languages_1.ll({
            key: "EditFVSPopupTitle",
            variables: [languages_1.ll(containerId || "")],
            languageId
        });
    const listFormatter = new Intl.ListFormat(languageId, {
        style: "long",
        type: "conjunction"
    });
    const setVisibleList = react_1.default.useCallback((newState, sortable, store) => {
        dispatch({
            type: "setVisibleFields",
            payload: { fields: newState, sortable, store }
        });
    }, [dispatch]);
    const setHiddenList = react_1.default.useCallback((newState, sortable, store) => {
        dispatch({
            type: "setHiddenFields",
            payload: { fields: newState, sortable, store }
        });
    }, [dispatch]);
    const [computedColumnCount, setComputedColumnCount] = react_1.default.useState(1);
    const popupGridRef = react_1.default.useRef(null);
    useResizeObserver_1.useResizeObserver(popupGridRef, dimensions => {
        const visibleFieldsArea = window.document.getElementById("visibleFieldsArea");
        const gridComputedStyle = visibleFieldsArea && window.getComputedStyle(visibleFieldsArea);
        gridComputedStyle &&
            setComputedColumnCount(gridComputedStyle
                .getPropertyValue("grid-template-columns")
                .split(" ").length);
    });
    const FVSLevelAutoComplete = props.fvsLevelAutoComplete;
    const filteredHiddenFields = state.hiddenFields.filter(f => f.fvsLevelId === state.selectedFVSLevelId);
    const filteredVisibleFields = state.visibleFields.filter(f => f.fvsLevelId === state.selectedFVSLevelId);
    return (react_1.default.createElement(ZPopup_1.ZPopup, { className: props.className, title: FVSLevelAutoComplete && props.fvsLevelData ? (react_1.default.createElement(TitleContainer, { style: {
                display: "inline-block",
                width: "100%"
            } },
            react_1.default.createElement(TitleWrapper, null, localizedTitle),
            react_1.default.createElement(AutoCompleteWrapper, null,
                react_1.default.createElement(FVSLevelAutoComplete, { data: autoCompleteData, columns: [
                        {
                            title: "CodeNumber",
                            field: "CodeNumber",
                            width: 150
                        },
                        {
                            title: "Value",
                            field: "Value",
                            width: 150
                        }
                    ], textField: "CodeNumber", label: "FVSLevel", value: state.selectedFVSLevel, onChange: (_event, selectedItem) => dispatch({
                        type: "setSelectedFVSLevel",
                        payload: selectedItem || defaultFVSLevel
                    }) })))) : (localizedTitle), localize: false, width: Math.round(innerWidth * 0.8), minWidth: 600, height: 500, allowMaximize: true, onClose: props.onCancel, visible: true },
        react_1.default.createElement(PopupGrid, { ref: popupGridRef },
            react_1.default.createElement(Instructions, null, languages_1.ll({
                key: "FieldVisibilityEditModeInstructionsTemplate",
                variables: [
                    listFormatter.format((allowedFieldStates || allFieldStates).map(state => languages_1.ll({ key: state, languageId })))
                ],
                languageId
            })),
            react_1.default.createElement("div", { style: {
                    width: "100%",
                    overflowY: "auto",
                    alignContent: "space-between"
                } },
                react_1.default.createElement(DroppablesGrid, { numberOfColumns: computedColumnCount },
                    react_1.default.createElement(FieldList, null,
                        props.numberOfColumns &&
                            props.allowEmptySpace !== false ? (react_1.default.createElement(react_sortablejs_1.ReactSortable, { forceFallback: true, list: [
                                {
                                    id: getUniqueNegativeId(),
                                    fvsLevelId: state.selectedFVSLevelId,
                                    ...fieldStates["Visible"]
                                }
                            ], setList: () => { }, animation: 150, group: {
                                name: "fieldVis",
                                put: false,
                                pull: (to, from, dragEl, event) => {
                                    if (to.el.id === "visibleFieldsArea") {
                                        return "clone";
                                    }
                                    else
                                        return false;
                                }
                            }, clone: item => ({
                                ...item,
                                id: getUniqueNegativeId()
                            }) },
                            react_1.default.createElement(EmptySpace, null, languages_1.ll({
                                key: "DragToAddEmptySpace",
                                languageId
                            })))) : null,
                        react_1.default.createElement(react_sortablejs_1.ReactSortable, { forceFallback: true, id: "hiddenFieldsArea", list: filteredHiddenFields, setList: setHiddenList, animation: 150, group: {
                                name: "fieldVis",
                                pull: (to, from, dragEl, event) => {
                                    return (dragEl.getAttribute("data-ignorefvs") !== "true");
                                }
                            } }, filteredHiddenFields.map((field, index) => (react_1.default.createElement(StyledPlaceholder, { id: field.id, key: `hidden-${field.id}`, disabled: true, hidden: field.hidden, required: field.required, editable: field.editable, ignoreFVS: field.ignoreFVS, onClick: (e) => {
                                e.preventDefault();
                                !field.ignoreFVS &&
                                    toggleItem(field.id);
                            } }, field.element))))),
                    react_1.default.createElement(Divider, null),
                    react_1.default.createElement(FieldList, null,
                        react_1.default.createElement(react_sortablejs_1.ReactSortable, { forceFallback: true, id: "visibleFieldsArea", list: filteredVisibleFields, setList: setVisibleList, animation: 150, group: {
                                name: "fieldVis",
                                pull: (to, from, dragEl, event) => {
                                    return (dragEl.getAttribute("data-ignorefvs") !== "true");
                                }
                            }, style: {
                                ...props.inlineStyle,
                                display: props.numberOfColumns
                                    ? "grid"
                                    : undefined,
                                gridTemplateColumns: props.numberOfColumns === "auto"
                                    ? "repeat(auto-fit,minmax(260px,1fr))"
                                    : props.numberOfColumns
                                        ? `repeat(${props.numberOfColumns}, 1fr)`
                                        : undefined
                            } }, filteredVisibleFields.map((field, index) => (react_1.default.createElement(StyledPlaceholder, { id: field.id, key: `visible-${field.id}`, disabled: true, hidden: field.hidden, required: field.required, editable: field.editable, ignoreFVS: field.ignoreFVS, onClick: (e) => {
                                e.preventDefault();
                                !field.ignoreFVS &&
                                    toggleItem(field.id);
                            } }, field.element))))))),
            react_1.default.createElement(PopupButtons, null,
                react_1.default.createElement(ZButton_1.ZButton, { primary: true, onClick: () => props.onSave &&
                        props.onSave([
                            ...state.hiddenFields,
                            ...state.visibleFields
                        ]) }, "SaveFieldVis"),
                react_1.default.createElement(ZButton_1.ZButton, { onClick: props.onCancel }, "Cancel")))));
})) `
   .k-content.k-window-content {
      display: inline-flex !important;
   }
`;
//# sourceMappingURL=FieldVisibilitySettingsPopup.js.map